import React, { Component } from 'react'


export default class BackgroundVideo extends Component {
    render() {
        const { src, muted, loop, autoPlay, controls, playsInline } = this.props

        return (
            <div className="background-video">
                <video controls={ controls ? true : false}
                       muted={ muted ? true : false }
                       loop={ loop ? true : false }
                       autoPlay={ autoPlay ? true : false }
                       playsInline={ playsInline ? true : false }>
                    <source src={ src } type="video/mp4" />
                </video>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/BackgroundVideo/index.js